module.exports = __webpack_public_path__ + "static/media/14.04950986.jpg";